import clsx from "clsx";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";

import { PaymentMethod } from "common/components/PaymentMethod";
import { Dialog, DialogContent } from "common/components/ui/Dialog";
import { Drawer, DrawerContent } from "common/components/ui/Drawer";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import Features from "./Features";
import Footer from "./Footer";
import Heading from "./Heading";

import WelcomeScreenDesktop from "assets/images/welcome-screen-desktop.png";
import WelcomeScreenMobile from "assets/images/welcome-screen-mobile.png";

const queryParam = "welcome-screen";

export default function WelcomeScreen() {
  const isDesktop = useTwBreakpoint("lg");
  const { subscription } = useSelectedWorkspaceContext();
  const [currentStep, setCurrentStep] = useState<"default" | "payment">(
    "default",
  );

  const [searchParams, setSearchParams] = useSearchParams();
  const welcomeScreen = !!searchParams.get(queryParam);

  function closeDialog() {
    setSearchParams((prevParams) => {
      const params = new URLSearchParams(prevParams);
      params.delete(queryParam);
      return params;
    });
  }

  const Component = isDesktop ? Dialog : Drawer;
  const Content = isDesktop ? DialogContent : DrawerContent;

  return (
    <Component open={!!welcomeScreen} dismissible={false}>
      <Content
        className={clsx(
          "[&>#close-button]:hidden transition-none",
          currentStep === "default" ? "lg:w-[900px] lg:p-1.5" : "lg:w-[448px]",
        )}
      >
        {currentStep === "payment" ? (
          <PaymentMethod
            onBack={() => setCurrentStep("default")}
            paymentSource={null}
            subscriptionId={subscription.id}
            onNext={closeDialog}
          />
        ) : (
          <div className="lg:border lg:border-black-200 lg:overflow-y-auto lg:scrollbar-thin lg:rounded-3xl">
            <img
              src={WelcomeScreenDesktop}
              alt=""
              className="rounded-3xl mb-6 max-lg:hidden"
            />

            <div className="flex flex-col lg:flex-row gap-3 lg:gap-20 lg:w-[740px] mx-auto">
              <Heading />
              <Features />
            </div>

            <img
              src={WelcomeScreenMobile}
              alt=""
              className="rounded-5xl mb-4 mt-8 lg:hidden"
            />

            <Footer
              onClose={closeDialog}
              onAddPaymentMethod={() => setCurrentStep("payment")}
            />
          </div>
        )}
      </Content>
    </Component>
  );
}
